export const UserTypes = {
    ADMIN: 'ADMIN',
    OWNER: 'OWNER',
    MAP_CREATOR: 'map_creator',
    MAP_MANAGER: 'map_manager', // For co admin
    MEMBER: 'MEMBER',
};
